import { MODAL_SHOW, MODAL_HIDE } from "../Actions/Modal.action";

export const modal = (state = { text: "", btntext: "" }, action) => {
  const { type, payload } = action;

  switch (type) {
    case MODAL_SHOW:
      return {
        ...state,
        text: payload.text,
        btntext: payload.btntext,
      };
    case MODAL_HIDE:
      return {
        ...state,
        text: "",
        btntext: "",
      };
    default:
      return state;
  }
};
